import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import PaginationAdvanced from "../PaginationAdvanced";
import { CSSTransitionGroup } from 'react-transition-group';
import Search from "../Search";
import { toastr } from "react-redux-toastr";
import moment from "moment";
import * as Constants from '../../constants';

import Index from "../Index";
import { fetchLeadFilterLogs } from "../../actions/index";

export class AdminLeadFilterLogsIndex extends Index {
  static propTypes = {
    match: PropTypes.object.isRequired,
    fetchLeadFilterLogs: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    leadFilterLogs: PropTypes.object
  };

  constructor(props) {
    super(props);
  }

  fetchData() {
    let newQueries = {
        page: this.state.page || 1,
        per_page: this.state.per_page || "",
        search: this.state.search || "",
        category: this.state.category || "",
        sort: this.state.sort || "",
        direction: this.state.direction || ""
      };
    this.props.fetchLeadFilterLogs(
      this.props.match.params.id,
      this.serialize(newQueries)
    );
    this.props.history.push(`/admin/leads/${this.props.match.params.id}/filter_logs${this.serialize(newQueries)}`);
  }

  renderFilterLogs() {
    if (!this.props.leadFilterLogs.data) {
      return (
        <tr>
          <td colSpan={9}>
            <div className="vertical-center">
              <CSSTransitionGroup
                transitionName="spinner"
                transitionAppear={true}
                transitionAppearTimeout={500}
              >
                <i className="fa fa-refresh fa-4x fa-spin" />
              </CSSTransitionGroup>
            </div>
          </td>
        </tr>
      );
    } else if (this.props.leadFilterLogs.data.length == 0) {
      return (
        <tr>
          <td colSpan={9}>
            <div className="well well-lg text-center">
              You have no filter logs.
            </div>
          </td>
        </tr>
      );
    }

    return this.props.leadFilterLogs.data.map(filterLog => {
      return (
        <tr key={filterLog.id}>
          <td> {moment(filterLog.created_at).format( "MM/DD/YYYY h:mm:ss A")} UTC</td>
          <td>{filterLog.lrm_action}</td>
          <td>{filterLog.match_status}</td>
          <td><pre>{ JSON.stringify(JSON.parse(filterLog.campaign_filters), null, 2) }</pre></td>
          <td><pre>{ JSON.stringify(filterLog.lrm_body, null, 2) }</pre></td>
          <td><pre>{ JSON.stringify(JSON.parse(filterLog.lead_data), null, 2) }</pre></td>
          <td><pre>{ JSON.stringify(JSON.parse(filterLog.sender_data), null, 2) }</pre></td>
        </tr>
      );
    });
  }

  render() {
    let count = 0;
    if (!this.props.leadFilterLogs || !this.props.leadFilterLogs.meta) {
      return (
        <div className="vertical-center">
          <CSSTransitionGroup
            transitionName="spinner"
            transitionAppear={true}
            transitionAppearTimeout={500}
          >
            <i className="fa fa-refresh fa-4x fa-spin" />
          </CSSTransitionGroup>
        </div>
      );
    }
    count = this.props.leadFilterLogs.meta.count;
    return (
      <div className="filter_logs_index">
        <div className="row">
          <h1>
            <span className="campaign_name">
              {this.props.leadFilterLogs.meta.lead_email} Filter Logs
            </span>
            <div className="pull-right">
              <Search
                handleSearch={this.handleSearch.bind(this)}
                searchStr={this.state.search}
              />
            </div>
          </h1>
          <table className="table table-striped">
            <thead>
              <tr>
                <th className="filter_logs_created_at">Date</th>
                <th className="filter_logs_lrm_action">Action</th>
                <th className="filter_logs_match_status">Status</th>
                <th className="filter_logs_campaign_filters">Filters</th>
                <th className="filter_logs_lrm_body">LRM Body</th>
                <th className="filter_logs_lead_data">Lead Data</th>
                <th className="filter_logs_sender_data">Sender Data</th>
                <th />
              </tr>
            </thead>
            <tbody>{this.renderFilterLogs()}</tbody>
          </table>
        </div>
        <div className="row text-right">
          <PaginationAdvanced
            handle={this.handlePagination.bind(this)}
            total={count}
            page={this.state.page}
            per_page={this.state.per_page}
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { leadFilterLogs: state.leadFilterLogs.all };
}

export default connect(
  mapStateToProps,
  { fetchLeadFilterLogs }
)(AdminLeadFilterLogsIndex);
